import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'ze-csv-warning-dialog',
  templateUrl: './csv-warning-dialog.component.html',
  styleUrls: ['./csv-warning-dialog.component.scss']
})
export class CsvWarningDialogComponent implements OnInit {
  title: string;
  message: string;
  
  constructor(
    public dialogRef: MatDialogRef<CsvWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CsvWarningDialogModel
  ) {
    this.title = data.title;
    this.message = data.message;
  }
  
  ngOnInit() {
  }
  
  onConfirm(): void {
    this.dialogRef.close(true);
  }
  
  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

export class CsvWarningDialogModel {
  constructor(public title: string, public message: string) {
  }
}

